import React from 'react';
import { Stack, TextField } from '@mui/material';

interface AdditionalFieldsRowProps {
    federalCapitalWeight: number | null;
    geographicAdjustmentFactor: number | null;
    inpatientHospitalDeductible: number | null;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const AdditionalFieldsRow: React.FC<AdditionalFieldsRowProps> = ({
    federalCapitalWeight,
    geographicAdjustmentFactor,
    inpatientHospitalDeductible,
    onChange
}) => {
    return (
        <Stack direction="row" spacing={2}>
            <TextField
                label="Federal Capital Weight"
                name="federalCapitalWeight"
                type="number"
                value={federalCapitalWeight || ''}
                onChange={onChange}
                fullWidth
                inputProps={{ step: 0.0001, min: 0 }}
            />
            <TextField
                label="Geographic Adjustment Factor"
                name="geographicAdjustmentFactor"
                type="number"
                value={geographicAdjustmentFactor || ''}
                onChange={onChange}
                fullWidth
                inputProps={{ step: 0.0001, min: 0 }}
            />
            <TextField
                label="Inpatient Hospital Deductible"
                name="inpatientHospitalDeductible"
                type="number"
                value={inpatientHospitalDeductible || ''}
                onChange={onChange}
                fullWidth
                inputProps={{ step: 0.01, min: 0 }}
            />
        </Stack>
    );
};
